import { AUTH_STORAGE_KEY } from 'utils/constants';
import authentication from './authentication';
import messages from 'messages/en';
import {history} from 'routes/history';
import { toast } from 'react-toastify';

export const headersWithBodyJSON = (
  headerOptions = {
    'Content-Type': 'application/json',
  },
) => {
  const headers = new Headers();
  Object.keys(headerOptions).forEach(key => {
    headers.append(key, headerOptions[key]);
  });

  const dataStorage = authentication.getSessionStorages(AUTH_STORAGE_KEY);
  if (dataStorage) {
    const dataAuth = authentication.decryptData(AUTH_STORAGE_KEY);
    const token = dataAuth.token;

    headers.append('Authorization', `Bearer ${token}`);
  }

  return headers;
};

export const headersWithAuth = (
  headerOptions = {},
) => {
  const headers = new Headers();

  const dataStorage = authentication.getSessionStorages(AUTH_STORAGE_KEY);
  if (dataStorage) {
    const dataAuth = authentication.decryptData(AUTH_STORAGE_KEY);
    const token = dataAuth.token;

    headers.append('Authorization', `Bearer ${token}`);
  }

  return headers;
};


export const handleResponse = (response, isHandleError = true) => {
  const contentType = response.headers.get('content-type');
  if (response.status >= 200 && response.status < 300) {
    if (contentType && contentType.indexOf('application/json') !== -1) {
      return response.json();
    } else if (contentType && contentType.indexOf('text/plain') !== -1) {
      return response.text();
    } else if (contentType) {
      if (response.blob) {
        return response.blob();
      }
    } else {
      return {};
    }
  } else {
    if(isHandleError){
      if (response.status === 404) {
        toast.error(messages.error.noService);
      } else if (response.status === 503) {
        history.push('/500');
      } else if (response.status === 504) {
        history.push('/500');
      }
    }
    
    return response.json().then(Promise.reject.bind(Promise));
  }
  return false;
};

export const handleResponseError = (error, pathBefore) => {
  const VALIDATION_ERROR = 'BAS-00001';
  const RECORD_NOT_FOUND = 'BAS-00002';
  const RECORD_ALREADY_EXIST = 'BAS-00003';
  const WF_NOT_FOUND = 'WFE-00001';
  const NOT_SUPPORT_TASKTYPE = 'WFE-00002';
  const EXIST_OBJECT = 'WFE-00003';
  const KEY_NOT_FOUND = 'WFE-00004';
  const EXIST_OBJECT_KEY = 'WFE-00005';
  const PENDING_TASK_ID_NOT_FOUND = 'WFE-00006';
  const PENDING_TASK_PROC_NOT_FOUND = 'WFE-00007';
  const PENDING_TASK_PROC_NOT_FOUND_2 = 'WFE-00008';
  const USER_ROLE_NOT_FOR_TASK = 'WFE-00009';
  const SAME_USER = 'WFE-00010';
  const NO_ASSIGNEE = 'WFE-00011';
  const USER_NOT_ASSIGNEE = 'WFE-00012';
  const FAILED_OBJECT_TO_JSON = 'WFE-90001';
  const FAILED_JSONOBJECT_TO_JSONSTRING = 'WFE-90002';
  const OBJECT_CLASS_NOT_FOUND = 'WFE-90003';
  const FAILED_CONSTRUCT_OBJECT = 'WFE-90004';
  const FAILED_UPLOAD_DOC = 'RTC-08020';

  const errorCodeList = {
    [RECORD_NOT_FOUND]: {
      message: messages.error.notFound,
      callback: () => {
        pathBefore ? history.push(pathBefore) : history.back();
      },
    },
    [VALIDATION_ERROR]: {
      message: messages.error.validationError,
      callback: () => {},
    },
    [RECORD_ALREADY_EXIST]: {
      message: messages.error.exist,
      callback: () => {},
    },
    [WF_NOT_FOUND]: {
      message: messages.errorWF.failedStart,
      callback: () => {},
    },
    [NOT_SUPPORT_TASKTYPE]: {
      message: messages.errorWF.failedStart,
      callback: () => {},
    },
    [EXIST_OBJECT]: {
      message: messages.errorWF.existObject,
      callback: () => {},
    },
    [KEY_NOT_FOUND]: {
      message: messages.errorWF.failedStart,
      callback: () => {},
    },
    [EXIST_OBJECT_KEY]: {
      message: messages.errorWF.existObjectKey,
      callback: () => {},
    },
    [PENDING_TASK_ID_NOT_FOUND]: {
      message: messages.errorWF.taskNotFound,
      callback: () => {
        pathBefore ? history.push(pathBefore) : history.back();
      },
    },
    [PENDING_TASK_PROC_NOT_FOUND]: {
      message: messages.errorWF.taskNotFound,
      callback: () => {},
    },
    [PENDING_TASK_PROC_NOT_FOUND_2]: {
      message: messages.errorWF.taskNotFound,
      callback: () => {},
    },
    [USER_ROLE_NOT_FOR_TASK]: {
      message: messages.errorWF.taskNotAvailable,
      callback: () => {},
    },
    [SAME_USER]: {
      message: messages.errorWF.taskNotAvailable,
      callback: () => {},
    },
    [NO_ASSIGNEE]: {
      message: messages.errorWF.taskNotAvailable,
      callback: () => {},
    },
    [USER_NOT_ASSIGNEE]: {
      message: messages.errorWF.taskNotAvailable,
      callback: () => {},
    },
    [FAILED_OBJECT_TO_JSON]: {
      message: messages.errorWF.errorSystem,
      callback: () => {},
    },
    [FAILED_JSONOBJECT_TO_JSONSTRING]: {
      message: messages.errorWF.errorSystem,
      callback: () => {},
    },
    [OBJECT_CLASS_NOT_FOUND]: {
      message: messages.errorWF.errorSystem,
      callback: () => {},
    },
    [FAILED_CONSTRUCT_OBJECT]: {
      message: messages.errorWF.errorSystem,
      callback: () => {},
    },
    [FAILED_UPLOAD_DOC]: {
      message: messages.errorWF.failedDocUpload,
      callback: () => {}
    }
  };

  if (error.code) {
    if (errorCodeList[error.code]) {
      toast.error(errorCodeList[error.code].message);
      errorCodeList[error.code].callback();
    }else{
      toast.error(error.message);
    }
  } else if (error.error === 'invalid_token') {
    toast.error(messages.error.expiredToken);
    authentication.deleteAllSession();
    history.push('/login');
  } else if (error.error === 'access_denied') {
    toast.error(messages.error.accessDenied); 
  } else if (error.error?.toLowerCase() === 'unauthorized'){
    toast.error(messages.error.expiredToken);
    authentication.deleteAllSession();
    history.push('/login');
  } else if (error.errorMessage) {
    toast.error(error.errorMessage);
  }
};

export const submit = (requestType, url, data = {}, requestOptions = {}, isHandleError = true) => {

  return new Promise((resolve, reject) => {
    if (requestType === 'GET') {
      const { headers = headersWithAuth() } = requestOptions;
      const newApiUrl = new URL(url);
      Object.keys(data).forEach(key => {
        newApiUrl.searchParams.append(key, data[key]);
      });
      fetch(
        newApiUrl,
        Object.assign(
          {
            method: 'GET',
            headers,
          },
          requestOptions,
        ),
      )
        .then(handleResponse)
        .then(response => {
          if (!response) {
            resolve(response);
          } else if (response.error) {
            handleResponseError(response);
            reject(response);
          } else {
            resolve(response);
          }
        })
        .catch(error => {
          handleResponseError(error);
          reject(error);
        });
    } else if (requestType === 'POST') {
      let { headers = headersWithBodyJSON(), bodyType = 'JSON' } = requestOptions;
      if(bodyType === 'FormData') headers = headersWithAuth();
      fetch(
        url,
        Object.assign(
          {
            method: 'POST',
            headers,
            body: bodyType === 'JSON' ? JSON.stringify(data) : data,
          },
          requestOptions,
        ),
      )
        .then(resp => handleResponse(resp, isHandleError))
        .then(response => {
          if (!response) {
            resolve(response);
          } else if (response.error) {
            if(isHandleError){
              handleResponseError(response);
            }
            reject(response);
          } else {
            resolve(response);
          }
        })
        .catch(error => {
          if(isHandleError){
            handleResponseError(error);
          }
          reject(error);
        });
    } else if (requestType === 'DELETE') {
      let { headers = headersWithAuth() } = requestOptions;
      if(data) headers = headersWithBodyJSON();
      fetch(
        url,
        Object.assign(
          {
            method: 'DELETE',
            headers,
            body: data ? JSON.stringify(data) : null
          },
          requestOptions,
        ),
      )
        .then(handleResponse)
        .then(response => {
          if (!response) {
            resolve(response);
          } else if (response.error) {
            handleResponseError(response);
            reject(response);
          } else {
            resolve(response);
          }
        })
        .catch(error => {
          handleResponseError(error);
          reject(error);
        });
    } else if (requestType === 'PUT') {
      const { headers = headersWithBodyJSON() } = requestOptions;
      fetch(
        url,
        Object.assign(
          {
            method: 'PUT',
            headers,
            body: JSON.stringify(data),
          },
          requestOptions,
        ),
      )
        .then(handleResponse)
        .then(response => {
          if (!response) {
            resolve(response);
          } else if (response.error) {
            handleResponseError(response);
            reject(response);
          } else {
            resolve(response);
          }
        })
        .catch(error => {
          handleResponseError(error);
          reject(error);
        });
    } else if (requestType === 'PATCH') {
      const { headers = headersWithBodyJSON() } = requestOptions;
      fetch(
        url,
        Object.assign(
          {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data),
          },
          requestOptions,
        ),
      )
        .then(handleResponse)
        .then(response => {
          if (!response) {
            resolve(response);
          } else if (response.error) {
            handleResponseError(response);
            reject(response);
          } else {
            resolve(response);
          }
        })
        .catch(error => {
          handleResponseError(error);
          reject(error);
        });
    }
  });
};
